import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { AlertModule } from './shared/component/global/alert/alert.module';
import { LoaderModule } from './shared/component/global/loader/loader.module';
import { OptimaTreeModule } from '@component';
import { CoreModule } from '@core';
import { MatInputModule } from '@angular/material/input';
import { BannerModule } from './shared/component/global/banner/banner.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    OptimaTreeModule,
    AlertModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    LoaderModule,
    MatInputModule,
    BannerModule,
  ],
  exports: [BrowserModule, BrowserAnimationsModule, CoreModule],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
